import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import { ContentProvider } from './context/ContentContext';

import Header from './components/Header';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import About from './components/About';
import Services from './components/Services';
import PiercingSection from './components/PiercingSection';
import BijouxSection from './components/BijouxSection';
import GrillzSection from './components/GrillzSection';
import StrassSection from './components/StrassSection';
import RealisationsSection from './components/RealisationsSection';
import ProtheseSection from './components/ProtheseSection';
import TattooGallery from './components/TattooGallery';
import Reviews from './components/Reviews';
import Contact from './components/Contact';
import Footer from './components/Footer';

import Login from './pages/Login';
import Admin from './pages/Admin';
import Denied from './pages/Denied';
import AuthCallback from './pages/AuthCallback';

const HomePage = () => (
  <ContentProvider>
    <LanguageProvider>
      <div className="App grain">
        <Header />
        <main>
          <Hero />
          <Marquee />
          <About />
          <Services />
          <PiercingSection />
          <BijouxSection />
          <GrillzSection />
          <StrassSection />
          <ProtheseSection category="acier" />
          <ProtheseSection category="titane" />
          <RealisationsSection />
          <TattooGallery />
          <Reviews />
          <Contact />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  </ContentProvider>
);

const AppRouter = () => {
  const location = useLocation();
  // Check URL fragment synchronously during render to handle OAuth callback
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/admin/login" element={<Login />} />
      <Route path="/admin/callback" element={<AuthCallback />} />
      <Route path="/admin/denied" element={<Denied />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
